import { Text } from "@fluentui/react-components";
import type { FC } from "react";
import { NotificationItem } from "../types";
import NotificationHistoryCard from "./NotificationHistoryCard";
import NotificationListHeader from "./NotificationListHeader";
import { useNotificationListStyles } from "./styles";

interface NotificationHistoryListProps {
  notifications: NotificationItem[];
  expandedIds: ReadonlySet<string>;
  onExpandedChange: (id: string) => void;
}

const NotificationHistoryList: FC<NotificationHistoryListProps> = ({
  notifications,
  expandedIds,
  onExpandedChange,
}) => {
  const styles = useNotificationListStyles();

  const emptyNotificationContent = (
    <div className={styles.emptyState}>
      <Text size={400} weight="semibold">
        No notifications found
      </Text>
      <br />
      <Text>Adjust the date range or filters to see more results.</Text>
    </div>
  );

  const notificationList = notifications.map((notification) => (
    <NotificationHistoryCard
      key={notification.id}
      notification={notification}
      expanded={expandedIds.has(notification.id)}
      onExpandedChange={onExpandedChange}
    />
  ));

  return (
    <section className={styles.list} aria-label="Notification logs list">
      <div className={styles.cardList}>
        <NotificationListHeader />
        {notifications.length === 0
          ? emptyNotificationContent
          : notificationList}
      </div>
    </section>
  );
};

export default NotificationHistoryList;
